var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup9613(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 108.624,
    height: 116.921,
    viewBox: "0 0 108.624 116.921",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9613",
    "data-name": "Group 9613",
    transform: "translate(-133 -203)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "out-of-stock_1_",
    "data-name": "out-of-stock (1)",
    transform: "translate(133 207.887)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11316",
    "data-name": "Path 11316",
    d: "M18.686,153.263l93.938,1.377a53.631,53.631,0,0,0-10.362-62.019H26.954a53.64,53.64,0,0,0-11.042,60.6Z",
    transform: "translate(-10.998 -72.354)",
    fill: "#47354f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11317",
    "data-name": "Path 11317",
    d: "M168.167,25.947h-13.52a12.742,12.742,0,0,1-11.224.839l-.375,18.607s-11.475,9.74,0,25.055v.311h25.119a4.07,4.07,0,0,0,4.07-4.07V30.017a4.07,4.07,0,0,0-4.07-4.07Z",
    transform: "translate(-110.169 -20.269)",
    fill: "#ffdd40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11318",
    "data-name": "Path 11318",
    d: "M94.46,45.394l.371-18.437a9.571,9.571,0,0,1-2.051-1.009H79.26a4.07,4.07,0,0,0-4.07,4.07V66.69a4.07,4.07,0,0,0,4.07,4.07h15.2V70.45C82.985,55.133,94.46,45.394,94.46,45.394Z",
    transform: "translate(-61.144 -20.27)",
    fill: "#ffb332"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11319",
    "data-name": "Path 11319",
    d: "M166.741,45.393h-9.482a1.679,1.679,0,0,1-1.679-1.679V25.947h12.841V43.714A1.68,1.68,0,0,1,166.741,45.393Z",
    transform: "translate(-123.943 -20.269)",
    fill: "#fff6d2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11320",
    "data-name": "Path 11320",
    d: "M174.134,232.786a3.465,3.465,0,0,0-3.465-3.465H149.852A17.766,17.766,0,0,1,135.812,231v25.085s-15.414,15.966-.9,30.541a53.412,53.412,0,0,0,21.629,4.548h.016q1.6,0,3.182-.1h0l14.4-9.526V232.786Z",
    transform: "translate(-102.933 -179.142)",
    fill: "#d1714b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11321",
    "data-name": "Path 11321",
    d: "M61.859,256.087V231.13a14.354,14.354,0,0,1-4.121-1.809H36.922a3.465,3.465,0,0,0-3.465,3.465V260.01A53.813,53.813,0,0,0,61.3,286.966C46.206,272.3,61.859,256.087,61.859,256.087Z",
    transform: "translate(-28.543 -179.142)",
    fill: "#bc6242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11322",
    "data-name": "Path 11322",
    d: "M159.827,256.162H146.739a2.318,2.318,0,0,1-2.318-2.318V229.32h17.724v24.523A2.318,2.318,0,0,1,159.827,256.162Z",
    transform: "translate(-115.226 -179.141)",
    fill: "#e58b6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11323",
    "data-name": "Path 11323",
    d: "M348.8,307.207h-13.52a12.642,12.642,0,0,1-12.067.451l.468,18.995s-11.14,9.468-.62,22.191a53.781,53.781,0,0,0,29.81-26.573V311.277A4.07,4.07,0,0,0,348.8,307.207Z",
    transform: "translate(-251.249 -239.985)",
    fill: "#49b1f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11324",
    "data-name": "Path 11324",
    d: "M275.24,326.653l-.463-18.78a8.188,8.188,0,0,1-1.217-.666H260.04a4.07,4.07,0,0,0-4.07,4.07v36.671a4.07,4.07,0,0,0,3.194,3.973,53.372,53.372,0,0,0,15.355-3.2c-10.345-12.661.721-22.067.721-22.067Z",
    transform: "translate(-202.366 -239.985)",
    fill: "#1e9ef4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11325",
    "data-name": "Path 11325",
    d: "M347.522,326.653H338.04a1.679,1.679,0,0,1-1.679-1.679V307.207H349.2v17.767A1.679,1.679,0,0,1,347.522,326.653Z",
    transform: "translate(-265.166 -239.985)",
    fill: "#9bd8f9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9601",
    "data-name": "Group 9601",
    transform: "translate(54.28 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11326",
    "data-name": "Path 11326",
    d: "M291.631,12.924c1.246,1.31,3.143,1.841,5.637,1.58l19.49,19.489a6.638,6.638,0,0,0,1.531,5.1c1.32,1.375,3.383,1.947,6.135,1.707a24.038,24.038,0,0,0,6.3-21.855c-2.3,2.2-4.673,3.246-7.051,3.109a9.713,9.713,0,0,1-6.3-3.372l-4.758-4.761a9.289,9.289,0,0,1-3.039-6.71,11.968,11.968,0,0,1,2.5-6.722,24.055,24.055,0,0,0-22.027,6.773c-.1,1.068-.158,3.839,1.58,5.666Z",
    transform: "translate(-283.238 0)",
    fill: "#ff4155"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11327",
    "data-name": "Path 11327",
    d: "M380.363,1.9c-1.953,2.72-4.715,8.357.667,13.739l4.732,4.732s6.015,7.593,13.7.441A24.038,24.038,0,0,0,380.363,1.9Z",
    transform: "translate(-351.89 -1.482)",
    fill: "#ff7186"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11328",
    "data-name": "Path 11328",
    d: "M292.931,58.412,273.212,38.694c-8.342.976-6.957-7.281-6.957-7.281A24.012,24.012,0,1,0,300.6,64.967c-8.839,1-7.667-6.554-7.667-6.554Z",
    transform: "translate(-259.058 -24.539)",
    fill: "#e80054"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9598",
    "data-name": "Group 9598",
    transform: "translate(13.174 13.174)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11329",
    "data-name": "Path 11329",
    d: "M335.23,80.9,320.243,65.919a3.346,3.346,0,0,1,4.732-4.732l14.986,14.986A3.346,3.346,0,1,1,335.23,80.9Z",
    transform: "translate(-319.263 -60.206)",
    fill: "#bec8f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9599",
    "data-name": "Group 9599",
    transform: "translate(13.174 20.667)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11330",
    "data-name": "Path 11330",
    d: "M320.243,107.655a3.346,3.346,0,0,1,0-4.733l7.493-7.493a3.346,3.346,0,0,1,4.732,4.732l-7.493,7.493A3.346,3.346,0,0,1,320.243,107.655Z",
    transform: "translate(-319.263 -94.45)",
    fill: "#d3dcfb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9600",
    "data-name": "Group 9600",
    transform: "translate(20.667 13.174)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11331",
    "data-name": "Path 11331",
    d: "M354.487,73.412a3.346,3.346,0,0,1,0-4.732l7.493-7.493a3.346,3.346,0,0,1,4.732,4.732l-7.493,7.493A3.346,3.346,0,0,1,354.487,73.412Z",
    transform: "translate(-353.507 -60.206)",
    fill: "#e9efff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "out-of-stock",
    transform: "translate(186.611 203)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9611",
    "data-name": "Group 9611",
    transform: "translate(0.841 0.841)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9610",
    "data-name": "Group 9610"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9609",
    "data-name": "Group 9609"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9602",
    "data-name": "Group 9602"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_169",
    "data-name": "Ellipse 169",
    cx: 26.666,
    cy: 26.666,
    r: 26.666,
    fill: "#ff4155"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9603",
    "data-name": "Group 9603",
    transform: "translate(0 6.988)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11332",
    "data-name": "Path 11332",
    d: "M36.179,117.522A26.665,26.665,0,0,1,16.5,72.862a26.665,26.665,0,1,0,37.672,37.672A26.568,26.568,0,0,1,36.179,117.522Z",
    transform: "translate(-7.83 -72.862)",
    fill: "#c21d44"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9604",
    "data-name": "Group 9604",
    transform: "translate(4.907 22.647)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11333",
    "data-name": "Path 11333",
    d: "M53.5,218.6H97.02v8.038H53.5Z",
    transform: "translate(-53.5 -218.596)",
    fill: "#e5ecf5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9605",
    "data-name": "Group 9605",
    transform: "translate(4.907 22.647)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11334",
    "data-name": "Path 11334",
    d: "M55.911,224.223V218.6H53.5v8.038H97.02v-2.411Z",
    transform: "translate(-53.5 -218.596)",
    fill: "#cad8eb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9606",
    "data-name": "Group 9606",
    transform: "translate(29.083 15.383)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11335",
    "data-name": "Path 11335",
    d: "M278.495,151h1.612v1.612h-1.612Z",
    transform: "translate(-278.495 -151)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9607",
    "data-name": "Group 9607",
    transform: "translate(7.324 25.054)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11336",
    "data-name": "Path 11336",
    d: "M75.995,241h1.612v1.612H75.995Z",
    transform: "translate(-75.995 -241)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9608",
    "data-name": "Group 9608",
    transform: "translate(10.561 25.054)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11337",
    "data-name": "Path 11337",
    d: "M106.123,241h1.612v1.612h-1.612Z",
    transform: "translate(-106.123 -241)",
    fill: "#fff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9612",
    "data-name": "Group 9612"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11338",
    "data-name": "Path 11338",
    d: "M46.957,8.057A27.507,27.507,0,1,0,25.008,54.9l.145-1.607A25.894,25.894,0,1,1,53.4,27.507,25.744,25.744,0,0,1,29.838,53.3l.143,1.607A27.508,27.508,0,0,0,46.957,8.057Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11339",
    "data-name": "Path 11339",
    d: "M248.09,496.866l-.049,1.613c.282.009.57.013.855.013s.57,0,.852-.013l-.049-1.613C249.164,496.882,248.619,496.882,248.09,496.866Z",
    transform: "translate(-221.388 -443.478)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11340",
    "data-name": "Path 11340",
    d: "M90.919,211.038H87.688v1.614h1.617v6.435H47.343v-6.435H86.074v-1.614H45.729V220.7h45.19Z",
    transform: "translate(-40.815 -188.362)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11341",
    "data-name": "Path 11341",
    d: "M150.859,120.884v4.823a3.228,3.228,0,1,0,6.455,0v-4.823H155.7v4.823a1.614,1.614,0,1,1-3.228,0v-4.823Z",
    transform: "translate(-134.649 -107.895)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11342",
    "data-name": "Path 11342",
    d: "M225.956,122.49h2.421v6.454h1.614V122.49h2.421v-1.606h-6.455Z",
    transform: "translate(-201.677 -107.895)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11343",
    "data-name": "Path 11343",
    d: "M82.217,125.738v-1.625a3.228,3.228,0,1,0-6.455,0v1.625a3.228,3.228,0,0,0,6.455,0Zm-4.841,0v-1.625a1.614,1.614,0,0,1,3.228,0v1.625a1.614,1.614,0,1,1-3.228,0Z",
    transform: "translate(-67.621 -107.895)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11344",
    "data-name": "Path 11344",
    d: "M315.017,125.738v-1.625a3.228,3.228,0,1,0-6.455,0v1.625a3.228,3.228,0,0,0,6.455,0Zm-4.841,0v-1.625a1.614,1.614,0,0,1,3.228,0v1.625a1.614,1.614,0,1,1-3.228,0Z",
    transform: "translate(-275.407 -107.895)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11345",
    "data-name": "Path 11345",
    d: "M388.5,122.5v-1.614h-4.843v8.06h1.614v-3.222h1.615v-1.614h-1.615V122.5Z",
    transform: "translate(-342.435 -107.895)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11346",
    "data-name": "Path 11346",
    d: "M169.886,324.1v-6.442h2.421v-1.627h-6.455v1.627h2.421V324.1Z",
    transform: "translate(-148.031 -282.071)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11347",
    "data-name": "Path 11347",
    d: "M312.5,317.643h1.617v-1.615H312.5a4.035,4.035,0,1,0,.008,8.069h1.611l0-1.6h-1.611a2.426,2.426,0,1,1,0-4.852Z",
    transform: "translate(-275.317 -282.071)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11348",
    "data-name": "Path 11348",
    d: "M101.537,322.5H98.285l.007,1.6h3.252a2.427,2.427,0,0,0-.009-4.853h-.823a.794.794,0,0,1,0-1.588h3.226v-1.627h-3.226a2.415,2.415,0,0,0,0,4.829h.823A.82.82,0,0,1,101.537,322.5Z",
    transform: "translate(-87.724 -282.071)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11349",
    "data-name": "Path 11349",
    d: "M236.933,324.1a3.221,3.221,0,0,0,3.228-3.215v-1.625a3.228,3.228,0,1,0-6.455,0v1.625A3.221,3.221,0,0,0,236.933,324.1Zm-1.614-4.84a1.614,1.614,0,1,1,3.228,0v1.625a1.614,1.614,0,0,1-3.228,0Z",
    transform: "translate(-208.594 -282.071)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11350",
    "data-name": "Path 11350",
    d: "M380.975,316.835v-.807h-1.614v.807a2.424,2.424,0,0,1-1.614,2.282v-3.089h-1.614V324.1h1.614v-3.082a2.424,2.424,0,0,1,1.614,2.282v.807h1.614V323.3a4.031,4.031,0,0,0-1.621-3.231A4.031,4.031,0,0,0,380.975,316.835Z",
    transform: "translate(-335.719 -282.071)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11351",
    "data-name": "Path 11351",
    d: "M0,0H4.7V1.614H0Z",
    transform: "translate(29.991 9.913) rotate(-82.008)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11352",
    "data-name": "Path 11352",
    d: "M0,0H1.614V4.7H0Z",
    transform: "translate(22.623 5.366) rotate(-7.992)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11353",
    "data-name": "Path 11353",
    d: "M248.49,47.081H250.1v4.7H248.49Z",
    transform: "translate(-221.79 -42.022)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11354",
    "data-name": "Path 11354",
    d: "M0,0H1.614V4.7H0Z",
    transform: "translate(29.978 45.132) rotate(-7.992)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11355",
    "data-name": "Path 11355",
    d: "M0,0H4.7V1.614H0Z",
    transform: "translate(22.61 49.678) rotate(-82.008)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11356",
    "data-name": "Path 11356",
    d: "M248.459,421.495h1.614v4.7h-1.614Z",
    transform: "translate(-221.762 -376.206)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup9613);
export default __webpack_public_path__ + "static/media/Group 9613.30ae9340bf4e650b1fda93e677860665.svg";
export { ForwardRef as ReactComponent };